import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "UsedProductFilter" })
export default class UsedProductFilter extends Vue {
    public localizer: any = Localizer;

    @Prop() readonly market: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public setMarketSelected(currentMarket: string): string {
        if(currentMarket !== this.market){
            return "border";
        }else{
            return "";
        }
    }
};